import { postRequest } from "../helpers/fetchHandler"
import { clearAuthToken, setAuthToken } from "../storage/authStorage"
import { clearPreferences } from "../storage/preferencesStorage"
import {
  REGISTER_LOADING,
  REGISTER_SUCCESS,
  REGISTER_FAILED,
  LOGIN_LOADING,
  LOGIN_FAILED,
  LOGIN_SUCCESS,
  LOG_OUT,
  REQUEST_RESET_EMAIL_LOADING,
  REQUEST_RESET_EMAIL_SUCCESS,
  REQUEST_RESET_EMAIL_FAILED,
  PASSWORD_RESET_LOADING,
  PASSWORD_RESET_FAILED,
  PASSWORD_RESET_SUCCESS,
} from "../constants/actionTypes"

export function logout() {
  return async dispatch => {
    clearAuthToken()
    await clearPreferences()
    dispatch({ type: LOG_OUT })
    return Promise.resolve()
  }
}

export function login(data) {
  return async dispatch => {
    dispatch({ type: LOGIN_LOADING })

    const url = "/api/v1/auth/login"
    try {
      const response = await postRequest({ url, data })
      setAuthToken(response)
      dispatch({ type: LOGIN_SUCCESS, payload: response, meta: { email: data.email } })
      return response
    } catch (error) {
      dispatch({ type: LOGIN_FAILED, error })
      throw error
    }
  }
}

export function register(data) {
  return async dispatch => {
    dispatch({ type: REGISTER_LOADING })

    const url = "/api/v1/auth/register/"
    try {
      const response = await postRequest({ url, data })
      dispatch({ type: REGISTER_SUCCESS, payload: { response }, meta: { email: data.email } })
      return response
    } catch (error) {
      dispatch({ type: REGISTER_FAILED, error })
      throw error
    }
  }
}

export function requestResetEmail(data) {
  return async dispatch => {
    dispatch({ type: REQUEST_RESET_EMAIL_LOADING })

    const url = "/api/v1/auth/request-reset-email"
    try {
      await postRequest({ url, data })
      dispatch({ type: REQUEST_RESET_EMAIL_SUCCESS })
      return Promise.resolve()
    } catch (error) {
      dispatch({ type: REQUEST_RESET_EMAIL_FAILED, error })
      throw error
    }
  }
}

export function resetPassword(data) {
  return async dispatch => {
    dispatch({ type: PASSWORD_RESET_LOADING })

    const url = "/api/v1/auth/reset-password"
    try {
      await postRequest({ url, data })
      dispatch({ type: PASSWORD_RESET_SUCCESS })
      return Promise.resolve()
    } catch (error) {
      dispatch({ type: PASSWORD_RESET_FAILED, error })
      throw error
    }
  }
}
